import { useCallback, useState } from 'react'
import * as Sentry from '@sentry/nextjs'
import { useTranslation } from 'next-i18next'

import { getStations } from 'features/facility/services/facilitiesListApi'
import type { Facility } from 'features/facility/types/facility'

export const useStations = () => {
  const { i18n } = useTranslation()
  const [stations, setStations] = useState<Facility[]>([])
  const [slug, setSlug] = useState<string | null>(null)
  const [isLoading, setLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const fetchStations = useCallback(
    async (prefectureId: number) => {
      setLoading(true)
      setIsError(false)

      try {
        const { data } = await getStations(prefectureId, i18n.language)
        setStations(data.facilities)
        setSlug(data.slug)
      } catch (error) {
        setIsError(true)
        Sentry.captureException(error instanceof Error ? error : new Error(String(error)), {
          tags: { hook: 'useStations' },
          extra: {
            prefectureId,
            locale: i18n.language,
          },
        })
      } finally {
        setLoading(false)
      }
    },
    [i18n.language]
  )

  return {
    stations,
    slug,
    isLoading,
    isError,
    fetchStations,
  }
}
